module.exports = __webpack_public_path__ + "b8452de275bb6c2a0b2dd9c6ef288809.pdf";